import * as React from "react";
import {
  Create,
  SimpleForm,
  CreateProps,
  NumberInput,
  TextInput,
  DateTimeInput,
  useGetIdentity,
  Loading,
  SelectInput,
} from "react-admin";
import {
  gql,
} from "@apollo/client";
import { authUserServiceClient } from '../util/AuthUsersServiceApolloClient'



const GET_AUTH_USER_BY_ROLE = gql`
  query getAuthUserByRole($where: AuthUserWhereInput) {
    authUsers(where: $where) {
      id
      firstName
      lastName
    }
  }
`;

export const SettlementCreate = (props: CreateProps): React.ReactElement => {
  const [authUserList, setAuthUserList] = React.useState(null);
  const [authUserListLoading, setAuthUserListLoading] = React.useState(false);
  const { identity, loading: identityLoading } = useGetIdentity();
  const getAuthUserList = async () => {
    setAuthUserListLoading(true);
    try {
      setAuthUserListLoading(false);
      const res = await authUserServiceClient.query({
        query: GET_AUTH_USER_BY_ROLE,
        variables: {
          where: {
            roles: {
              path: ["doctor_sale"],
              array_contains: ["doctor_sale.doctor"],
            },
          },
        },
      });
      const authUsers = res.data.authUsers;
      setAuthUserList(authUsers);
    } catch (error) {
      setAuthUserListLoading(false);
    }
  };
  const mapToChoises = (list: any[] | any) => {
    return list.map((item: any) => ({id: item.id, name: `${item.firstName} ${item.lastName}`}))
  }
  React.useEffect(() => {
    getAuthUserList();
  }, []);

  return authUserListLoading && identityLoading ? (
    <Loading />
  ) : (
    <Create {...props}>
      <SimpleForm>
        <NumberInput label="مبلغ واریزی (ریال)" source="amount" />
        <TextInput label="ایجاد شده توسط" source="createdBy" disabled defaultValue={identity?.id} />
        <TextInput label="شماره حساب مبدا" source="sourceAccountNo" />
        <TextInput
          label="شماره حساب مقصد"
          source="destinationAccountNo"
        />

        {/* <TextInput label="doctor id" source="doctorId" /> */}
        <SelectInput
          source="doctorId"
          label={"پزشک"}
          choices={authUserList ? mapToChoises(authUserList) : []}
        />
        <DateTimeInput label="تاریخ واریز" source="settledAt" />
        <TextInput label="وضعیت" source="status" />
        <TextInput label="بروزرسانی توسط" source="updatedBy" disabled defaultValue={identity?.id} />
      </SimpleForm>
    </Create>
  );
};
